import { lazy, Suspense } from 'react';
import { TaskDrawerHost } from '@/features/tasks/task-drawer';
import { useCreateDialog } from './create-store';

const NewTaskDialog = lazy(() =>
  import('@/features/tasks/new-task-dialog').then((m) => ({ default: m.NewTaskDialog })),
);
const NewRequestDialog = lazy(() =>
  import('@/features/inbox/inbox-page').then((m) => ({ default: m.NewRequestDialog })),
);

export function GlobalDialogs() {
  const { open, projectId, close } = useCreateDialog();
  return (
    <>
      <TaskDrawerHost />
      <Suspense>
        {open === 'task' && (
          <NewTaskDialog open onOpenChange={(o) => !o && close()} {...(projectId ? { projectId } : {})} />
        )}
        {open === 'request' && <NewRequestDialog open onOpenChange={(o) => !o && close()} />}
      </Suspense>
    </>
  );
}
